export const hawkersReport = {
	title: "Panel Ambulantes",
	description: "Vea el desempeño general de los ambulantes en el local",
	general: {
		title: "Panel General",
		hawkerSelect: "Seleccione un ambulante",
		totalizers: {
			launchedProductsTotal: "Total de productos registrados",
			returnedProductsTotal: "Total de productos devueltos",
			commissionTotal: "Total en comisiones",
			salesTotal: "Total en ventas",
		},
		table: {
			sales: "Ventas",
			devolutions: "Devoluciones",
			paymentMethod: "Métodos de pago",
			productsRelease: "Registro de productos",
			productsCancellation: "Cancelación de productos",
			noReturnNoSalesProducts: "Productos sin devolución y sin venta",
			columns: {
				product: "Producto",
				quantity: "Cantidad",
				unitValue: "Valor unitario",
				total: "Total",
				commission: "Comisión",
				paymentMethod: "Método de pago",
				value: "Valor",
			},
		},
	},
	summary: {
		title: "Resumen por sesión y ciclo",
		summary: "Resumen",
		filterBreak: "Mostrar solo sesiones con faltantes",
		filterClosure: "Mostrar solo sesiones con cierre pendiente",
		columns: {
			session: "Sesión",
			hawkerName: "Ambulante",
			pub: "Bar",
			hawkerDocument: "Documento",
			cycleCount: "Ciclos",
			change: "Cambio",
			receivedValue: "Valor recibido",
			break: "Faltante de caja",
			openedAt: "Apertura",
			closedAt: "Cierre",
			openClosure: "Cierre abierto",
			cycle: "Ciclo",
			previousBalance: "Saldo anterior",
			closingValue: "Valor cierre",
			balance: "Saldo final",
			cashierNameOpener: "Apertura caja",
			cashierNameCloser: "Cierre caja",
		},
	},
	ranking: {
		title: "Ranking",
		filename: "ranking",
		columns: {
			name: "Nombre",
			document: "Documento",
			commission: "Comisión",
			total: "Total Vendido",
		},
	},
	releases: {
		title: "Registros por ambulantes",
		quantityProducts: "Cant. de productos",
		totalValueReleases: "Valor total",
		filename: "ficha-ambulante-{{hawker}}",
		hawkerRecord: "Ficha Ambulante",
		name: "Nombre del ambulante",
		columns: {
			hawkerName: "Nombre",
			hawkerDocument: "Documento",
			total: "Total",
			productName: "Producto",
			quantity: "Cantidad",
			value: "Valor unitario",
		},
	},
	cashierClosing: {
		title: "Cierre de caja de ambulante",
		name: "Nombre",
		document: "Documento",
		begin: "Apertura",
		end: "Cierre",
		closingValue: "Valor cierre",
		financialResume: "Resumen financiero",
		resume: "Resumen",
		value: "Valor",
		products: "Productos",
		product: "Producto",
		quantity: "Cantidad",
		unitValue: "Valor unitario",
		total: "Total",
		paymentMethods: "Métodos de pago",
		paymentMethod: "Método de pago",
		date: "Fecha y hora",
		changeEntries: "Registros de cambio",
		bleedings: "Sangrías",
		cycleClosings: "Cierres de ciclos",
		sessionClosings: "Cierres de sesiones",
		financialSummaryTitles: {
			changeFundsValue: "Total de cambio",
			bleedingsValue: "Total de sangría",
			cyclesReceivedValue: "Totalizador de ciclos",
			sessionsReceivedValue: "Totalizador de sesiones",
			cashValue: "Valor en efectivo",
			valueWithCashier: "Valor en posesión del cajero",
			cashierDiffValue: "Caja cerrada con faltante/sobrante",
		},
		diffValue: "Faltante/Sobrante de caja",
	},
	filter: {
		filter: "Filtrar",
		clickToFilter: "Haga clic para filtrar",
		employee: {
			label: "Empleado",
			description: "Ingrese el nombre del empleado",
			title: "Filtrar por empleado",
		},
		hawkerName: {
			label: "Nombre del ambulante",
			description: "Ingrese el nombre del ambulante",
			title: "Filtrar por nombre del ambulante",
		},
		hawkerDocument: {
			label: "Documento del ambulante",
			description: "Ingrese el documento del ambulante",
			title: "Filtrar por documento del ambulante",
		},
		cashierName: {
			label: "Nombre del cajero",
			description: "Ingrese el nombre del cajero",
			title: "Filtrar por nombre del cajero",
		},
		cashierDocument: {
			label: "Documento del cajero",
			description: "Ingrese el documento del cajero",
			title: "Filtrar por documento del cajero",
		},
	},
};
